import { labelConstants } from "../../constants";

export function labels(state = {}, action) {
  switch (action.type) {
    // get all
    case labelConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case labelConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case labelConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case labelConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case labelConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case labelConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case labelConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case labelConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case labelConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case labelConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case labelConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case labelConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case labelConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
